module.exports = __webpack_public_path__ + "static/img/3.97238d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/04/3.png
// module id = 0JtB
// module chunks = 1